// test1836
(1836 && 0);
